export default {
  systemManager: {
    userGroupManager: {
      getGroupList: '/api/userGroupManager/getGroupList',
      addGroup: '/api/userGroupManager/addGroup',
      updateGroup: '/api/userGroupManager/updateGroup',
      grantGroup: '/api/userGroupManager/grantGroup',
      delGroup: '/api/userGroupManager/delGroup',
      loadUserList: '/api/userGroupManager/loadUserList'
    },
    userManager: {
      login: '/api/userManager/doLogin',
      //以其他账号进入系统
      runAsOther: '/api/userManager/runAsOther',
      // 返回当前角色
      backSelf: '/api/userManager/backSelf',
      //退出
      logout: '/api/userManager/logout',
      //获取用户的入口信息
      getUserEntries: '/api/userManager/getUserEntries',
      getUserMenuAndPermission: '/api/userManager/getUserMenuAndPermission',
      // 更改用户的主题
      changeUserTheme: '/api/userManager/changeUserTheme',
      //获取用户列表
      getUserList: '/api/userManager/getUserList',
      //撤销用户
      terminate: '/api/userManager/terminate',
      //创建用户
      saveUser: '/api/userManager/saveUser',
      //更新用户
      updateUser: '/api/userManager/updateUser',
      //重置密码
      resetPassword: '/api/userManager/resetPassword',
      //修改密码
      modifyPassword: '/api/userManager/modifyPassword',
      //激活用户
      activate: '/api/userManager/activate',
      // 挂起用户
      suspend: '/api/userManager/suspend',
      // 获取用户可配置角色列表
      getUserRoleList: '/api/userManager/getUserRoleList',
      // 修改用户角色
      grantUser: '/api/userManager/grantUser',
      // 获取用户列表（无操作权限拦截接口）
      getAllUser: '/api/userManager/getAllUser',
      // 获取用户列表（无操作权限拦截接口）
      getUserOptions: '/api/userManager/getUserOptions',
      updateSign: 'api/userManager/updateSign',
      getSign: 'api/userManager/getSign'
    },
    roleManager: {
      // 角色分页列表
      getRoleList: "/api/roleManager/getRoleList",
      // 删除角色
      delRole: '/api/roleManager/delRoles',
      // 新增角色
      addRole: '/api/roleManager/addRole',
      // 更新角色
      updateRole: '/api/roleManager/updateRole',
      // 获取角色可配置的入口菜单信息
      getRoleConfigEntry: '/api/roleManager/getRoleConfigEntry',
      // 入口配置
      entryConfig: '/api/roleManager/entryConfig',
      // 修改角色 入口 菜单的关系
      changeMenuStatus: '/api/roleManager/changeMenuStatus',
      //菜单操作权限变化
      changeMenuPermission: '/api/roleManager/changeMenuPermission',
      // 获取角色列表 无权限
      getRoleOptions: '/api/roleManager/getRoleOptions',
      getUserRoleList: 'api/roleManager/getUserRoleList'
    },
    rightDutyManage: {
      // 权力责任清单列表查询
      getRightDutyList: '/api/rightDutyManager/getRightDutyList',
      // id查询权力责任清单
      getRightDuty: '/api/rightDutyManager/getRightDuty',
      // 新增
      saveOrUpdateRightDuty: '/api/rightDutyManager/saveOrUpdateRightDuty',
      // 删除
      delRightDuty: '/api/rightDutyManager/delRightDuty',
      // 导出模板下载
      exportTempRightDuty: '/api/rightDutyManager/exportTempRightDuty',
      // 模板导入
      importRightDuty: '/api/rightDutyManager/importRightDuty',
    }
  }

}
